import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { IoIosArrowDown } from "react-icons/io";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { OrderStatusMap } from '../utils/Enums';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AssignOrder, ChangeOrderStatus, Order } from '../services/orderServices';
import FormatPrice from '../utils/FormatePrice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAgentsList } from '../redux/slices/agentLookUpSlice';
import { fetchOrders } from '../redux/slices/orderSlice';
import Loader from '../components/Loader';

export const OrderDrawer = ({ isOpen, onClose, id}) => {
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const agentList = useSelector((state) => state.agentList?.agentList?.data || []);
    
    const dispatch = useDispatch();

    useEffect(() =>{
        dispatch(fetchAgentsList())
    }, [dispatch]);
  
    useEffect(() => {
        const fetchOrderDetails = async () => {
            setLoading(true)

            try {
            const response = await Order(id);
            setOrderDetails(response?.data);
            } catch (error) {
            console.error("Error fetching order details:", error);
            toast.error("Failed to load order details.");
            } finally {
            setLoading(false);
            }
        }
        fetchOrderDetails();
    }, [id]);

    const handleChange = async (event) => {
        const value = event.target.value;
        setSelectedValue(value);

        try {
            const res = await AssignOrder({
                agentId: parseInt(value),
                orderId: id,
              })
            console.log(res)
            if(res.statusCode === 200){
                toast.success(res.message);
                dispatch(fetchOrders())
                onClose()
            } else {
                toast.error(res.message)
            }
            } catch (error) {
            console.error("Error updating status:", error);
            }
        };

        const handleStatusChange = async (event) => {
            const value = parseInt(event.target.value);
            setSelectedStatus(value);
    
            const body = {
                deliveryTime: new Date().toISOString(),
                status: parseInt(value),
                orderId: id
            };
    
            try {
                const response = await ChangeOrderStatus(body);
                if (response?.statusCode === 200) {
                    // toast.success(response.message);
                    dispatch(fetchOrders())
                    onClose()
                } else {
                    console.error(response?.message);
                }
            } catch (error) {
                console.error("Error updating order status:", error);
            }
        };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
    slotProps={{
        root: {
          className: `
            backdrop-blur-[1px] 
            bg-orange/20 
            rounded-tl-2xl 
          `,
        },
      }}  
    >
      <ModalClose />
      {loading ?
        ( <div className='mt-16'>
            <Loader />
        </div>        
        ): (
        orderDetails && (
        <main className="p-5 bg-[#F9F9F9]">
                <h2 className="capitalize text-[24px] capitalize font-bold text-primaryRed mt-5">order details</h2>
                <p type="small" className="mb-6 mt-4 text-sm text-[#0A0A0ACC]">
                    Get a clear view of each order's journey—track items, update status, and keep customers informed every step of the way.
                </p>
                <div className="grid place-items-end">
                    <div className={`
                        flex items-center justify-between px-4 py-2 rounded-md
                         ${
                            OrderStatusMap[orderDetails.orderStatus] === 'Delivered'
                            ? 'bg-[#008000] text-white'
                            : OrderStatusMap[orderDetails.orderStatus] === 'Pending'
                            ? 'bg-orange text-black'
                            : 'bg-[#4A90E2] text-white'
                        }  
                    `}>
                        <p className='text-white text-sm'>{OrderStatusMap[orderDetails.orderStatus] || "Unknown Status"}</p>
                        <IoIosArrowDown className='text-white text-lg ml-2' />
                    </div>
                </div>
                <div className='bg-white mt-4 text-sm px-2 rounded-md'>
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className='capitalize'>order i.d</p>
                        <p className='capitalize'>{orderDetails?.code}</p>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className='capitalize'>Update order status</p>
                        <select id="statusDropdown" onChange={handleStatusChange} className='focus:outine-none outline-none'>
                            <option value="" disabled>Status</option>
                            {Object.entries(OrderStatusMap).map(([key, value]) => (
                                <option key={key} value={key}>
                                {value}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className=''>Assigned delivery agent </p>
                        <div className="flex items-center ">
                            {agentList && (
                            <select id="statusDropdown" value={selectedValue} onChange={handleChange}       className='focus:outine-none outline-none'>
                                <option value="" disabled>Assign Agent</option>
                                {agentList.map((agent) => (
                                    <option value={agent.id}>{agent.firstName}</option>
                                ))}
                            </select>

                            )}
                        </div>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                </div>
                <div className='bg-white mt-5 px-2 text-sm rounded-md'>
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className='capitalize'>name</p>
                        <p className='capitalize'>{orderDetails?.customerDetails?.name}</p>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className=''>Phone number</p>
                        <p className='capitalize'>{orderDetails?.customerDetails?.phoneNumber}</p>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className='capitalize'>email</p>
                        <p className=''>{orderDetails?.customerDetails?.email}</p>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                    <div className='flex justify-between items-center px-4 py-2'>
                        <p className='capitalize'>address</p>
                        <p className=''>{orderDetails?.customerDetails?.address}</p>
                    </div>
                    <div className="h-[1px] w-full border-0 bg-primaryGray" />
                </div>
                {orderDetails?.foodPackDetails && (
                    orderDetails?.foodPackDetails.map((foodDetails) => (
                    <div key={foodDetails.id}>
                        <div className="flex items-center justify-between my-4">
                            <p className='font-semibold'>Order Summary</p>
                            <div className="flex items-center bg-black justify between px-4 py-2 rounded-md">
                                <p className='text-white text-sm'>{`${foodDetails.quantity} Packs`}</p>
                            </div>
                        </div>
                        <Accordion sx={{borderRadius: "10px", marginTop: "10px"}}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon className='text-white' />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    color: 'white',
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                    backgroundColor:
                                        OrderStatusMap[orderDetails.orderStatus] === "Delivered"
                                            ? "#008000"
                                            : OrderStatusMap[orderDetails.orderStatus] === "Pending"
                                            ? "orange"
                                            : "#4A90E2",
                                        color:
                                        OrderStatusMap[orderDetails.orderStatus] === "Pending"
                                            ? "black"
                                            : "white",
                                    '&:hover': {
                                    backgroundColor: '',
                                    },
                                }}
                                className=''
                            >
                            <p>{`${foodDetails.quantity} Packs`}</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='flex justify-between text-sm items-center px-2 py-2'>
                                    <p className='capitalize'>{foodDetails.name}</p>
                                    <p className=''>{FormatPrice(foodDetails.price)}</p>
                                </div>
                                <div className="h-[1px] w-full border-0 bg-primaryGray" />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    )) 
                )}
                <div className='bg-white p-4 mt-6 rounded-md shadow-md'>
                    <div className='flex items-center justify-between my-2 font-semibold'>
                        <p className='text-md capitalize'>transaction</p>
                        <div className={`
                            bg-[#008000] px-4 py-2 rounded-md
                            flex items-center justify-between px-4 py-2 rounded-md
                            ${
                                OrderStatusMap[orderDetails.orderStatus] === 'Delivered'
                                ? 'bg-[#008000] text-white'
                                : OrderStatusMap[orderDetails.orderStatus] === 'Pending'
                                ? 'bg-orange text-black'
                                : 'bg-[#4A90E2] text-white'
                            }  
                        `}>
                            <p className='text-white text-md'>{OrderStatusMap[orderDetails.orderStatus] || "Unknown Status"}</p>
                        </div>
                    </div>
                    <div className='flex items-center justify-between font-semibold'>
                        <p className='text-md capitalize'>{orderDetails.code}</p>
                        <p className='text-md capitalize'>{FormatPrice(orderDetails.amount)}</p>
                    </div>
                </div>
        </main>
      ))}
    </Drawer>
  )
}
